import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { QRCodeSVG } from 'qrcode.react';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { FileDown, Linkedin, Globe } from 'lucide-react';

const LINKEDIN_URL = 'https://www.linkedin.com/in/jenaro-vega';
const RESUME_PDF_PATH = '/files/JenaroVegaBecerrilResumePublic2026.pdf';

const Connect = () => {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';
  const resumePdfUrl = `${baseUrl}${RESUME_PDF_PATH}`;
  const siteUrl = baseUrl;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Header />
      <main className="pt-20 min-h-screen">
        <div className="container py-12 md:py-20">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-2">
            Connect with me
          </h1>
          <p className="text-muted-foreground text-center mb-12">
            Scan a QR code to open my portfolio, resume, or LinkedIn
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 max-w-4xl mx-auto">
            <div className="flex flex-col items-center p-6 rounded-xl border bg-card text-card-foreground shadow-sm">
              <div className="p-4 bg-white rounded-lg mb-4">
                <QRCodeSVG value={siteUrl} size={160} level="M" />
              </div>
              <h2 className="font-semibold text-lg flex items-center gap-2">
                <Globe className="h-5 w-5" />
                My site
              </h2>
              <p className="text-sm text-muted-foreground text-center mt-1">
                Opens this portfolio
              </p>
            </div>

            <div className="flex flex-col items-center p-6 rounded-xl border bg-card text-card-foreground shadow-sm">
              <div className="p-4 bg-white rounded-lg mb-4">
                <QRCodeSVG value={resumePdfUrl} size={160} level="M" />
              </div>
              <h2 className="font-semibold text-lg flex items-center gap-2">
                <FileDown className="h-5 w-5" />
                Resume
              </h2>
              <p className="text-sm text-muted-foreground text-center mt-1">
                Opens PDF in browser (view or download)
              </p>
            </div>

            <div className="flex flex-col items-center p-6 rounded-xl border bg-card text-card-foreground shadow-sm sm:col-span-2 lg:col-span-1">
              <div className="p-4 bg-white rounded-lg mb-4">
                <QRCodeSVG value={LINKEDIN_URL} size={160} level="M" />
              </div>
              <h2 className="font-semibold text-lg flex items-center gap-2">
                <Linkedin className="h-5 w-5" />
                LinkedIn
              </h2>
              <p className="text-sm text-muted-foreground text-center mt-1">
                Opens my LinkedIn profile
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </motion.div>
  );
};

export default Connect;
